var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.6914H10.0083",
    stroke: "#726C6C",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3327 5.6914V4.02473C13.3327 3.5827 13.1571 3.15878 12.8445 2.84622C12.532 2.53366 12.108 2.35806 11.666 2.35806H8.33268C7.89065 2.35806 7.46673 2.53366 7.15417 2.84622C6.84161 3.15878 6.66602 3.5827 6.66602 4.02473V5.6914",
    stroke: "#726C6C",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3327 11.5247C15.86 13.1572 12.9623 14.0275 9.99935 14.0275C7.03639 14.0275 4.13869 13.1572 1.66602 11.5247",
    stroke: "#726C6C",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.666 5.69141H3.33268C2.41221 5.69141 1.66602 6.4376 1.66602 7.35807V15.6914C1.66602 16.6119 2.41221 17.3581 3.33268 17.3581H16.666C17.5865 17.3581 18.3327 16.6119 18.3327 15.6914V7.35807C18.3327 6.4376 17.5865 5.69141 16.666 5.69141Z",
    stroke: "#726C6C",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/bag.4f29a1453b5435ace56bdd3f33b4ffcd.svg";
export { ForwardRef as ReactComponent };